document.addEventListener("DOMContentLoaded", function () {
  // Product Variation Switcher with AJAX
  (function () {
    const SECTIONS_TO_UPDATE = [
      "shopify-section-template--19695950823498__main",
      "shopify-section-template--19695950823498__product_video_aca3gd",
      "shopify-section-template--19695950823498__product_description_WyW3kc",
      "shopify-section-template--17861417435210__main",
      "shopify-section-template--17861417435210__product_video_aca3gd",
      "shopify-section-template--17861417435210__product_description_WyW3kc",
    ];

    function executeScript(script) {
      const newScript = document.createElement("script");
      Array.from(script.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
      newScript.innerHTML = script.innerHTML;
      document.head.appendChild(newScript).parentNode.removeChild(newScript);
    }

    function attachVariationSwatchListeners() {
      document.querySelectorAll(".variation-swatch").forEach(function (swatch) {
        swatch.addEventListener("click", function (event) {
          event.preventDefault();

          const url = swatch.getAttribute("data-href");
          if (!url) return;

          // Add loading state to body
          document.body.classList.add("page-loading");

          // Extract product handle from URL
          const urlParts = url.split("/");
          const handle = urlParts[urlParts.length - 1] || urlParts[urlParts.length - 2];

          fetch(url)
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.text();
            })
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");

              // Update page title
              const newTitle = doc.querySelector("title");
              if (newTitle) {
                document.title = newTitle.textContent;
              }

              // Update URL without page reload
              window.history.pushState({ path: url }, "", url);

              // Update sections

              SECTIONS_TO_UPDATE.forEach((sectionId) => {
                const newSections = doc.querySelectorAll(`[id="${sectionId}"]`);
                const currentSections = document.querySelectorAll(`[id="${sectionId}"]`);

                newSections.forEach((newSection, idx) => {
                  const currentSection = currentSections[idx];
                  if (newSection && currentSection) {
                    currentSection.innerHTML = newSection.innerHTML;
                    Array.from(newSection.getElementsByTagName("script")).forEach(executeScript);
                  }
                });
              });

              // Update active state for variation swatches
              document.querySelectorAll(".variation-swatch").forEach((s) => s.classList.remove("active"));
              swatch.classList.add("active");

              // Re-attach listeners for new content
              attachVariationSwatchListeners();

              // Set active variation swatch
              setActiveVariationSwatch();

              // Re-initialize product functionality
              if (typeof findAndUpdateVariant === "function") {
                findAndUpdateVariant();
              }

              // Re-fetch and update B2B prices after AJAX content update
              if (typeof fetchAndUpdateB2BPrices === "function") {
                fetchAndUpdateB2BPrices();
              }

              // Re-initialize B2B modal
              initB2BModal();

              attachListeners();

              initGallery();
            })
            .catch((error) => {
              console.error("Error fetching product variation:", error);
            })
            .finally(() => {
              document.body.classList.remove("page-loading");
              swatch.classList.remove("variation-loading");
            });
        });
      });
    }

    function attachListeners() {
      document.querySelectorAll(".variant-picker input[type=radio]").forEach((radio) => {
        radio.addEventListener("change", () => {
          findAndUpdateVariant();
        });
      });

      document.querySelectorAll("input[type=radio]:not(.variant-picker input[type=radio])").forEach((radio) => {
        radio.addEventListener("change", () => {
          findAndUpdateVariant();
        });
      });

      // Attach event listener to Add to Cart button
      const addToCartButton = document.getElementById("AddToCart");
      if (addToCartButton) {
        addToCartButton.addEventListener("click", handleAddToCart);
      } else {
        console.warn("AddToCart button not found - cart functionality will not be available");
      }
    }

    function setActiveVariationSwatch() {
      const currentUrl = window.location.pathname;
      document.querySelectorAll(".variation-swatch").forEach((swatch) => {
        const swatchUrl = swatch.getAttribute("data-href");
        if (swatchUrl === currentUrl) {
          swatch.classList.add("active");
        } else {
          swatch.classList.remove("active");
        }
      });
    }

    attachListeners();

    // Handle browser back/forward buttons
    window.addEventListener("popstate", function (event) {
      if (event.state && event.state.path) {
        location.reload();
      }
    });

    // Initialize on DOM ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        attachVariationSwatchListeners();
        setActiveVariationSwatch();
      });
    } else {
      attachVariationSwatchListeners();
      setActiveVariationSwatch();
    }
  })();

  function getVariantFromSwatches() {
    const variantArr = [];

    document.querySelectorAll(".variant-picker input[type=radio]:checked").forEach((el) => {
      const optionPosition = el.getAttribute("data-option-position");
      if (optionPosition) {
        const label = document.querySelector(`label[for="${el.id}"]`);
        let optionValueName = el.value;

        if (label) {
          optionValueName = label.textContent.trim();
          optionValueName = optionValueName.replace(/^\s*[\u2713\u2714\u2022]\s*/, "");
        }

        variantArr.push({
          value: optionValueName,
          index: `option${optionPosition}`,
        });
      }
    });

    if (variantArr.length === 0) {
      document.querySelectorAll("input[type=radio]:checked").forEach((el) => {
        const optionPosition = el.getAttribute("data-option-position");
        if (optionPosition) {
          const label = document.querySelector(`label[for="${el.id}"]`);
          let optionValueName = el.value;

          if (label) {
            optionValueName = label.textContent.trim();
            optionValueName = optionValueName.replace(/^\s*[\u2713\u2714\u2022]\s*/, "");
          }

          variantArr.push({
            value: optionValueName,
            index: `option${optionPosition}`,
          });
        }
      });
    }

    return variantArr;
  }

  const theme = {
    Currency: (function () {
      const moneyFormat = "${{amount}}";

      function formatMoney(cents, format) {
        if (typeof cents === "string") {
          cents = cents.replace(".", "");
        }
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || moneyFormat;

        function formatWithDelimiters(number, precision, thousands, decimal) {
          thousands = thousands || ",";
          decimal = decimal || ".";

          if (isNaN(number) || number === null) return 0;

          number = (number / 100.0).toFixed(precision);

          const parts = number.split(".");
          const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);

          // Include cents if precision > 0 and cents exist
          if (precision > 0 && parts[1]) {
            return dollarsAmount + decimal + parts[1];
          }

          return dollarsAmount;
        }

        let value = "";
        switch (formatString.match(placeholderRegex)[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ");
            break;
          case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'");
            break;
        }

        return formatString.replace(placeholderRegex, value);
      }

      return { formatMoney: formatMoney };
    })(),
  };

  document.querySelectorAll(".swatch").forEach((swatch) => {
    swatch.addEventListener("click", () => {
      const optionsWrap = swatch.closest(".options_wrap");
      if (optionsWrap) {
        optionsWrap.querySelectorAll(".swatch").forEach((s) => s.classList.remove("active"));
        swatch.classList.add("active");
      }
      setTimeout(() => findAndUpdateVariant(), 10);
    });
  });

  function update_variant_id(variant) {
    const variantIdElement = document.getElementById("variant_id");
    if (variantIdElement) {
      variantIdElement.value = variant;
    }
  }

  function update_slider_image(variant) {
    const selectedInput =
      document.querySelector(".variant-picker input[type=radio]:checked[data-featured-media]") ||
      document.querySelector("input[type=radio]:checked[data-featured-media]");

    if (selectedInput) {
      const featuredMediaId = selectedInput.getAttribute("data-featured-media");

      const gallerySlides = document.querySelectorAll(".product-gallery__media[data-media-id]");
      let targetSlide = null;
      let targetSlideIndex = -1;

      gallerySlides.forEach((slide, index) => {
        const slideMediaId = slide.getAttribute("data-media-id");
        if (slideMediaId === featuredMediaId) {
          targetSlide = slide;
          targetSlideIndex = index;
        }
      });

      if (targetSlide) {
        const swiperSlideIndex = targetSlide.getAttribute("data-swiper-slide-index");
        if (swiperSlideIndex !== null && window.productMediaSwiper) {
          const slideIndex = parseInt(swiperSlideIndex);
          window.productMediaSwiper.slideTo(slideIndex);
        } else if (window.productMediaSwiper) {
          window.productMediaSwiper.slideTo(targetSlideIndex);
        }
      }
    }
  }

  function formatPriceWithSeparateSpans(price) {
    const formattedPrice = theme.Currency.formatMoney(price, theme.moneyFormat);
    // Extract currency symbol, dollars, and cents
    const match = formattedPrice.match(/^([^\d]*)(\d+)\.(\d+)$/);
    if (match) {
      const [, symbol, dollars, cents] = match;
      return `<span>${symbol}</span><span>${dollars}</span><span>${cents}</span>`;
    }
    // Handle prices without decimal (like $34)
    const wholeMatch = formattedPrice.match(/^([^\d]*)(\d+)$/);
    if (wholeMatch) {
      const [, symbol, dollars, cents] = wholeMatch;
      return `<span>${symbol}</span><span>${dollars}</span><span>${cents}</span>`;
    }
    // Fallback for any other formats
    const symbolMatch = formattedPrice.match(/^([^\d]*)(.+)$/);
    if (symbolMatch) {
      const [, symbol, amount, cents] = symbolMatch;
      return `<span>${symbol}</span><span>${amount}</span><span>${cents}</span>`;
    }
    return `<span>${formattedPrice}</span>`;
  }

  function update_b2b_price_display(price) {
    const priceInDollars = price / 100;
    const dollars = Math.floor(priceInDollars);
    const cents = Math.round((priceInDollars - dollars) * 100)
      .toString()
      .padStart(2, "0");

    const priceElements = document.querySelectorAll("[data-b2b-price], [data-suggested-retail-price]");

    priceElements.forEach((priceElement) => {
      if (priceElement) {
        priceElement.innerHTML = `<span>$</span><span>${dollars}</span><span>${cents}</span>`;
        priceElement.classList.remove("skeleton-loader");
        priceElement.removeAttribute("style");
        priceElement.classList.add("flex");
      }
    });
  }

  function update_product_price(variant) {
    const regular_price = variant.price;
    const compare_price = variant.compare_at_price;

    let output = "";
    let stickyOutput = "";
    if (compare_price === 0 || compare_price === undefined) {
      const regular_price_output = `<div id="regular_price" class="money product-info__price-amount">${formatPriceWithSeparateSpans(regular_price)}</div>`;
      output += regular_price_output;
      stickyOutput += regular_price_output;
    } else {
      if (compare_price > regular_price) {
        const compare_price_output = `<div id="compare_price" class="money product-info__price-amount"> <del class="flex">${formatPriceWithSeparateSpans(compare_price)}</del></div>`;
        output += compare_price_output;
      }
      const regular_price_output = `<div id="regular_price" class="money product-info__price-amount">${formatPriceWithSeparateSpans(regular_price)}</div>`;
      output += regular_price_output;
      stickyOutput += regular_price_output;
    }

    const productPriceElement = document.getElementById("product_price");
    if (productPriceElement) {
      productPriceElement.innerHTML = output;
    }
    const stickyPrice = document.getElementById("sticky_price");
    if (stickyPrice) {
      stickyPrice.innerHTML = stickyOutput;
    }
  }

  function productHasTag(tag) {
    return window.product && Array.isArray(window.product.tags) && window.product.tags.includes(tag);
  }

  function update_add_to_cart_text(variant) {
    const addToCart = document.getElementById("AddToCart");
    if (!addToCart) {
      return; // Exit early if AddToCart button doesn't exist
    }
    const isAnnouncement = productHasTag("announcement");
    if (!variant.available) {
      if (isAnnouncement) {
        addToCart.style.display = "flex";
        addToCart.removeAttribute("disabled");
      } else {
        addToCart.setAttribute("disabled", true);
      }

      const buttonText = isAnnouncement ? "Coming Soon" : "Sold Out";
      // Preserve the icon by only updating the text node
      const textNode = addToCart.childNodes[0];
      if (textNode && textNode.nodeType === Node.TEXT_NODE) {
        textNode.textContent = buttonText;
      } else {
        // Fallback: reconstruct with icon
        const icon = addToCart.querySelector("svg");
        addToCart.innerHTML = buttonText;
        if (icon) addToCart.appendChild(icon);
      }
    } else {
      addToCart.style.display = "flex";
      addToCart.removeAttribute("disabled");

      // Check if product has 'pre-order' tag
      const isPreOrder = productHasTag("pre-order");
      const buttonText = isAnnouncement ? "Coming Soon" : isPreOrder ? "Pre-order now" : "Add to Cart";

      // Preserve the icon by only updating the text node
      const textNode = addToCart.childNodes[0];
      if (textNode && textNode.nodeType === Node.TEXT_NODE) {
        textNode.textContent = buttonText;
      } else {
        // Fallback: reconstruct with icon
        const icon = addToCart.querySelector("svg");
        addToCart.innerHTML = buttonText;
        if (icon) addToCart.appendChild(icon);
      }
    }
  }

  function update_sold_out_badge(variant) {
    const soldOutBadges = document.querySelectorAll("sold-out-badge, .badge--sold-out");

    if (variant.available) {
      soldOutBadges.forEach((badge) => {
        badge.style.display = "none";
      });
    } else {
      soldOutBadges.forEach((badge) => {
        badge.style.display = "inline-block";
      });
    }
  }

  function update_selected_option_display(variant) {
    const selectedValues = getVariantFromSwatches();

    selectedValues.forEach((option) => {
      const displayElements = document.querySelectorAll(
        `[id*="selected-option-${option.index.replace("option", "")}-"]`
      );

      displayElements.forEach((element) => {
        element.textContent = option.value;
      });
    });

    if (variant) {
      if (variant.option1) {
        const option1Elements = document.querySelectorAll('[id*="selected-option-1-"]');
        option1Elements.forEach((element) => {
          element.textContent = variant.option1;
        });
      }

      if (variant.option2) {
        const option2Elements = document.querySelectorAll('[id*="selected-option-2-"]');
        option2Elements.forEach((element) => {
          element.textContent = variant.option2;
        });
      }

      if (variant.option3) {
        const option3Elements = document.querySelectorAll('[id*="selected-option-3-"]');
        option3Elements.forEach((element) => {
          element.textContent = variant.option3;
        });
      }
    }
  }

  function findAndUpdateVariant() {
    // Check if product data exists
    if (!window.product || !window.product.variants) {
      console.warn("Product data not available - variant updates will be skipped");
      return;
    }

    const selectedValues = getVariantFromSwatches();
    const variants = window.product.variants;
    let found = null;

    variants.forEach((variant, index) => {
      let satisfied = true;

      selectedValues.forEach((option) => {
        const variantOptionValue = variant[option.index];

        if (satisfied) {
          satisfied = option.value === decodeHtml(variantOptionValue);
        }
      });

      if (satisfied) {
        found = variant;
      }
    });

    if (found) {
      update_add_to_cart_text(found);
      update_sold_out_badge(found);
      update_variant_id(found.id);
      if (found.featured_image) {
        update_slider_image(found.featured_image);
      }
      update_product_price(found);
      update_selected_option_display(found);

      if (window.isB2B && found.b2bPrice) {
        update_b2b_price_display(found.b2bPrice);
      }
    }
  }

  function fetchAndUpdateB2BPrices() {
    if (window.isB2B) {
      fetch(
        "https://faas-fra1-afec6ce7.doserverless.co/api/v1/web/fn-5748b803-616c-4545-acec-c19d12f859e1/node-fetch/get-product",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            product: window.product.handle,
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (window.product && Array.isArray(window.product.variants) && Array.isArray(data.variants)) {
            window.product.variants.forEach((v, i) => {
              const fromData = data.variants.find((dv) => dv.id === v.id);
              if (fromData && typeof fromData.price !== "undefined") {
                v.b2bPrice = fromData.price;
              }
            });
          }
          findAndUpdateVariant();

          // Update B2B price display with current variant's B2B price
          const currentVariant =
            window.product.variants.find((v) => v.id === parseInt(document.getElementById("variant_id")?.value)) ||
            window.product.variants[0];
          if (currentVariant && currentVariant.b2bPrice) {
            update_b2b_price_display(currentVariant.b2bPrice);
          }
        });
    }
  }

  fetchAndUpdateB2BPrices();

  function decodeHtml(str) {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  }

  if (document.querySelector(".variant-picker") || document.querySelector("input[type=radio][data-option-position]")) {
    if (window.product && window.product.variants && window.product.variants.length > 0) {
      const firstVariant = window.product.variants.find((v) => v.available) || window.product.variants[0];
      update_product_price(firstVariant);
    }
    findAndUpdateVariant();
  } else {
    if (window.product && window.product.variants && window.product.variants.length > 0) {
      const firstVariant = window.product.variants.find((v) => v.available) || window.product.variants[0];
      if (firstVariant) {
        update_add_to_cart_text(firstVariant);
        update_sold_out_badge(firstVariant);
        update_variant_id(firstVariant.id);
        if (firstVariant.featured_image) {
          update_slider_image(firstVariant.featured_image);
        }
        update_product_price(firstVariant);
        update_selected_option_display(firstVariant);
      }
    }
  }

  function findProductWishlistElement(selector) {
    const buyButtons = document.querySelector(".buy-buttons__group");
    return (
      (buyButtons && buyButtons.querySelector(selector)) || document.querySelector(`[data-wishlist-btn] ${selector}`)
    );
  }

  function triggerAnnouncementWishlist(retryCount = 0) {
    const alreadyInWishlist = findProductWishlistElement('.frcp-wishlist-product-btn[data-frcp-in-wishlist="true"]');
    if (alreadyInWishlist) {
      return true;
    }

    const wishlistButton = findProductWishlistElement(
      '.frcp-wishlist-btn--add[data-frcp-in-wishlist="false"], .frcp-wishlist-product-btn[data-frcp-in-wishlist="false"]'
    );

    if (!wishlistButton) {
      if (retryCount < 10) {
        setTimeout(() => triggerAnnouncementWishlist(retryCount + 1), 100);
        return true;
      }

      console.warn("Wishlist button not found for announcement product");
      return false;
    }

    wishlistButton.click();
    return true;
  }

  // Add to Cart button functionality
  function handleAddToCart(event) {
    event.preventDefault();

    const addToCartButton = document.getElementById("AddToCart");
    const variantIdInput = document.getElementById("variant_id");

    if (!addToCartButton) {
      console.error("AddToCart button not found");
      return;
    }

    if (productHasTag("announcement")) {
      triggerAnnouncementWishlist();
      return;
    }

    if (!variantIdInput || !variantIdInput.value) {
      console.error("No variant selected or variant_id input not found");
      return;
    }

    const variantId = variantIdInput.value;

    // Get quantity from quantity selector
    let quantity = 1; // Default fallback
    const quantitySelector =
      document.querySelector('.quantity-selector input[type="number"]') ||
      document.querySelector('input[name="quantity"]') ||
      document.querySelector(".quantity-input") ||
      document.querySelector("[data-quantity-input]");

    if (quantitySelector) {
      const selectedQuantity = parseInt(quantitySelector.value);
      if (selectedQuantity && selectedQuantity > 0) {
        quantity = selectedQuantity;
      }
    }

    // Disable button and show loading state
    addToCartButton.disabled = true;
    const originalText = addToCartButton.textContent;

    // Preserve the icon when showing "ADDING..." state
    const textNode = addToCartButton.childNodes[0];
    if (textNode && textNode.nodeType === Node.TEXT_NODE) {
      textNode.textContent = "ADDING...";
    } else {
      // Fallback: reconstruct with icon
      const icon = addToCartButton.querySelector("svg");
      addToCartButton.innerHTML = "ADDING...";
      if (icon) addToCartButton.appendChild(icon);
    }

    // Use AJAX cart drawer if available, otherwise fallback to redirect
    if (window.ajaxCartDrawer) {
      window.ajaxCartDrawer
        .addToCart(variantId, quantity)
        .then((data) => {
          // Show success feedback
          const textNode = addToCartButton.childNodes[0];
          if (textNode && textNode.nodeType === Node.TEXT_NODE) {
            textNode.textContent = "ADDED!";
          } else {
            const icon = addToCartButton.querySelector("svg");
            addToCartButton.innerHTML = "ADDED!";
            if (icon) addToCartButton.appendChild(icon);
          }

          // Reset button text after a moment
          setTimeout(() => {
            const textNode = addToCartButton.childNodes[0];
            if (textNode && textNode.nodeType === Node.TEXT_NODE) {
              textNode.textContent = originalText;
            } else {
              const icon = addToCartButton.querySelector("svg");
              addToCartButton.innerHTML = originalText;
              if (icon) addToCartButton.appendChild(icon);
            }
          }, 1500);
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);

          // Show error feedback
          const textNode = addToCartButton.childNodes[0];
          if (textNode && textNode.nodeType === Node.TEXT_NODE) {
            textNode.textContent = "ERROR - TRY AGAIN";
            setTimeout(() => {
              textNode.textContent = originalText;
            }, 2000);
          } else {
            const icon = addToCartButton.querySelector("svg");
            addToCartButton.innerHTML = "ERROR - TRY AGAIN";
            if (icon) addToCartButton.appendChild(icon);
            setTimeout(() => {
              addToCartButton.innerHTML = originalText;
              if (icon) addToCartButton.appendChild(icon);
            }, 2000);
          }
        })
        .finally(() => {
          addToCartButton.disabled = false;
        });
    } else {
      // Fallback to original redirect behavior
      const formData = {
        items: [
          {
            id: variantId,
            quantity: quantity,
          },
        ],
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          // Update cart count if element exists
          const cartCount = document.querySelector(".cart-count, [data-cart-count]");
          if (cartCount) {
            fetch("/cart.js")
              .then((response) => response.json())
              .then((cart) => {
                cartCount.textContent = cart.item_count;
              });
          }

          // Show success feedback
          const textNode = addToCartButton.childNodes[0];
          if (textNode && textNode.nodeType === Node.TEXT_NODE) {
            textNode.textContent = "ADDED!";
          } else {
            const icon = addToCartButton.querySelector("svg");
            addToCartButton.innerHTML = "ADDED!";
            if (icon) addToCartButton.appendChild(icon);
          }

          // Redirect to cart page after brief success message
          window.location.href = "/cart";
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);

          // Show error feedback
          const textNode = addToCartButton.childNodes[0];
          if (textNode && textNode.nodeType === Node.TEXT_NODE) {
            textNode.textContent = "ERROR - TRY AGAIN";
            setTimeout(() => {
              textNode.textContent = originalText;
            }, 2000);
          } else {
            const icon = addToCartButton.querySelector("svg");
            addToCartButton.innerHTML = "ERROR - TRY AGAIN";
            if (icon) addToCartButton.appendChild(icon);
            setTimeout(() => {
              addToCartButton.innerHTML = originalText;
              if (icon) addToCartButton.appendChild(icon);
            }, 2000);
          }
        })
        .finally(() => {
          addToCartButton.disabled = false;
        });
    }
  }

  // B2B Contact Modal functionality
  function initB2BModal() {
    const b2bContactButton = document.getElementById("b2bContact");
    const b2bModal = document.getElementById("b2bContactModal");
    const closeModalButton = document.getElementById("closeB2bModal");
    const b2bForm = document.getElementById("b2bContactForm");

    if (!b2bContactButton || !b2bModal) {
      console.warn("B2B Contact modal elements not found");
      return;
    }

    // Open modal
    b2bContactButton.addEventListener("click", function (event) {
      event.preventDefault();
      b2bModal.style.display = "block";
      // Use setTimeout to ensure the display change takes effect before adding the class
      setTimeout(() => {
        b2bModal.classList.add("is-open");
      }, 10);

      // Prevent body scroll when modal is open
      document.body.style.overflow = "hidden";
    });

    // Close modal function
    function closeModal() {
      b2bModal.classList.remove("is-open");
      // Wait for transition to complete before hiding
      setTimeout(() => {
        b2bModal.style.display = "none";
      }, 300);

      // Restore body scroll
      document.body.style.overflow = "";
    }

    // Close modal on close button click
    if (closeModalButton) {
      closeModalButton.addEventListener("click", closeModal);
    }

    // Close modal on overlay click
    b2bModal.addEventListener("click", function (event) {
      if (event.target === b2bModal || event.target.classList.contains("b2b-modal__overlay")) {
        closeModal();
      }
    });

    // Close modal on Escape key
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && b2bModal.classList.contains("is-open")) {
        closeModal();
      }
    });

    // Handle form submission
    if (b2bForm) {
      b2bForm.addEventListener("submit", function (event) {
        event.preventDefault();

        // Get form data
        const formData = new FormData(b2bForm);
        const data = Object.fromEntries(formData);

        // Basic validation
        if (!data.name || !data.email) {
          alert("Please fill in all required fields (Name and Email).");
          return;
        }

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(data.email)) {
          alert("Please enter a valid email address.");
          return;
        }

        // Show loading state
        const submitButton = b2bForm.querySelector(".b2b-modal__submit");
        const originalText = submitButton.innerHTML;
        submitButton.innerHTML = "SUBMITTING...";
        submitButton.disabled = true;

        // Here you would typically send the data to your server
        // For now, we'll simulate a successful submission
        setTimeout(() => {
          alert("Thank you for your inquiry! We'll get back to you soon.");
          closeModal();
          b2bForm.reset();

          // Restore button
          submitButton.innerHTML = originalText;
          submitButton.disabled = false;
        }, 1000);

        console.log("B2B Contact Form Data:", data);
      });
    }
  }

  // Initialize B2B modal
  initB2BModal();

  initGallery();

  function initGallery() {
    const mediaSwiper = document.querySelector(".product-gallery");
    const mediaSwiperEl = document.querySelector(".product-gallery__media-list");
    const thumbSwiperEl = document.querySelector(".product-gallery__thumbnail-list");

    if (!mediaSwiper || !mediaSwiperEl || !thumbSwiperEl) {
      return;
    }

    const slides = mediaSwiperEl.querySelectorAll(".swiper-slide");
    if (slides.length === 0) {
      console.warn("No slides found in media swiper");
      return;
    }

    const thumbsSwiper = new Swiper(thumbSwiperEl, {
      slidesPerView: 3,
      spaceBetween: 4,
      loop: false,
      breakpoints: {
        990: {
          slidesPerView: "auto",
          direction: "vertical",
        },
      },
    });

    window.productMediaSwiper = new Swiper(mediaSwiperEl, {
      slidesPerView: 1,
      spaceBetween: 8,
      loop: false,
      thumbs: { swiper: thumbsSwiper },
      watchSlidesProgress: true,
      navigation: {
        nextEl: mediaSwiper.querySelector(".slider__btn--next"),
        prevEl: mediaSwiper.querySelector(".slider__btn--prev"),
      },
    });

    // Check for shipping bullet and update label if needed
    const bulletList = document.querySelector(".product-info__bullet-list");
    if (bulletList) {
      const shippingImg = bulletList.querySelector('img[alt*="Shipping"]');
      if (shippingImg) {
        const shippingLabel = document.querySelector("[data-shipping-date-label]");
        if (shippingLabel && !shippingLabel.textContent.trim()) {
          shippingLabel.textContent = shippingImg.alt;
        }
      }
    }
  }
});
